const Header = props => {
  return (
    <div className="flex mx-8 lg:mx-10 2xl:mx-28">
      <div className="w-full hidden-div py-6 md:py-16">
        <span className="flex hidden-text text-blue-500 font-headline text-4xl sm:text-7xl lg:text-8xl xl:text-9xl">
          {props.bigTitle}
        </span>
        <span className="upper-div m-auto left-0 right-0">
          <h3 className="text-center md:text-left pl-5 lg:pl-7 xl:pl-12 font-headline font-bold upper-text text-blue-500 text-base md:text-3xl">
            {props.title}
          </h3>
        </span>
      </div>
    </div>
  );
};
export default Header;
